export default [
	    {
	        "id": "chat_recipients__recipient_id",
	        "header": "Recipient",
	        "fieldName": "users__username",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100,
	        "editField": "chat_recipients__recipient_id"
	    }
	];